// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"style_button-wrapper__EVahk","button":"style_button__1JmbH","button-arrow":"style_button-arrow__b1pl6","button-loading":"style_button-loading__qm5uO"};